import { render } from "./agentOut.vue?vue&type=template&id=0647d3b6"
import script from "./agentOut.vue?vue&type=script&lang=js"
export * from "./agentOut.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\loong\\develop\\project\\tianyuan\\ty-maintain-web\\ty-maintain-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__